import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import "./SeriesDescriptions.css";
export const SeriesDescriptions = (props) => {
    const descriptions = props.descriptionStrings;
    const lItemClasses = "optionsListItem_Series " +
        (props.is3Stack
            ? "optionsListItem_Series_3Stack"
            : "optionsListItem_Series_4Stack");
    let num = 0;
    const optionsList = descriptions.map((option) => {
        num++;
        const uniqueKey = "uID" + num;
        return (_jsx("li", Object.assign({ className: lItemClasses }, { children: option }), uniqueKey));
    });
    return (_jsx(_Fragment, { children: _jsx("ul", Object.assign({ className: "optionsList_Series" }, { children: optionsList })) }));
};
